// extracted by mini-css-extract-plugin
export default {"container":"container__YnXFO","containerInvoice":"containerInvoice__cc0Gi","navigateButton":"navigateButton__UUzay","titleWrapper":"title-wrapper__atgqQ","title":"title__l6V4K"};